import 'css-chunksrc/client/scenes/wbs/list/styles.scss';export default {
  "list": "_list_1xfqq_1",
  "contextualMenu": "_contextualMenu_1xfqq_5",
  "hovered": "_hovered_1xfqq_9",
  "name": "_name_1xfqq_9",
  "main": "_main_1xfqq_16",
  "displayedContextualMenu": "_displayedContextualMenu_1xfqq_47",
  "iconBox": "_iconBox_1xfqq_51",
  "icon": "_icon_1xfqq_51",
  "elementsNbr": "_elementsNbr_1xfqq_67",
  "allocated": "_allocated_1xfqq_74",
  "openedIcon": "_openedIcon_1xfqq_80"
};